import React from 'react';
import WaveTitle from './WaveTitle';
import './HomeSection.css';

const videoSrc = process.env.PUBLIC_URL + "/assets/bg.mp4";

const HomeSection = ({ theme }) => (
  <main className={`home-section theme-${theme}`}>
    <video className="background-video" src={videoSrc} autoPlay loop muted playsInline />
    <div className="overlay"></div>
    <WaveTitle />
  </main>
);

export default HomeSection;
